const calcChecker1 = (firstNineDigits) => {
  let sum = null

  for (let j = 0; j < 9; ++j) {
    sum += firstNineDigits.toString().charAt(j) * (10 - j)
  }

  const lastSumChecker1 = sum % 11

  return (lastSumChecker1 < 2) ? 0 : 11 - lastSumChecker1
}

const calcChecker2 = (cpfWithChecker1) => {
  let sum = null

  for (let k = 0; k < 10; ++k) {
    sum += cpfWithChecker1.toString().charAt(k) * (11 - k)
  }

  const lastSumChecker2 = sum % 11

  return (lastSumChecker2 < 2) ? 0 : 11 - lastSumChecker2
}

export const validaCpf = (rule, value, callback) => {
  const cleanCPF = value.replace(/\.|-|\s/g, '')
  const firstNineDigits = cleanCPF.substring(0, 9)
  const checker = cleanCPF.substring(9, 11)

  if (cleanCPF.length !== 11) {
    callback(new Error('O CPF não possui 11 digitos'))
  }

  for (let i = 0; i < 10; i++) {
    if ('' + firstNineDigits + checker === Array(12).join(i)) {
      return false
    }
  }

  const checker1 = calcChecker1(firstNineDigits)
  const checker2 = calcChecker2(firstNineDigits + '' + checker1)

  if (!(checker.toString() === checker1.toString() + checker2.toString())) {
    callback(new Error('O CPF é inválido'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/validators/cpf.js